import React from "react";
import './style.css';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";
import { local_routes } from 'utils/Routes';

class searchResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            SearchResImg: null,
            plImage: null
        };
    }

    render() {
        let nav_link = this.props.nav_link;
        if (this.props.org_friendly_url) {
            nav_link = local_routes.workspace+'/'+this.props.org_friendly_url+nav_link;
        }
        return (
            <div className="search-result">
                <div className="pks-details">
                    <div>
                        <NavLink to={nav_link} className="pkColor">
                            <h3 className="item-heading">{this.props.heading}</h3>
                            <div className="item">
                                <Row>
                                    <Col lg={3} md={3}>
                                        <img src={this.props.img} className="img-fluid item-img" alt="SearchResImg" />
                                    </Col>
                                    <Col lg={9} md={9}>
                                        <div className="searchData">
                                            <div dangerouslySetInnerHTML={{ __html: this.props.pk_content }} />
                                            {this.props.url}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </NavLink>
                    </div>
                </div>
            </div>
        );
    }
}
export default withRouter(searchResults);
